import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { PublicHealthStepParams } from './types'
import { employmentSchema } from './types'

export const employmentStatus = (params: PublicHealthStepParams) => {
  const schema = employmentSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_publicHealth:steps.employment_status.title',
        },
      },
      {
        type: 'choice',
        options:
          schema.shape.products.shape.mga_public_health_de.shape.configuration_parameters.shape.employment_status.options.map(
            (option) => ({
              value: option,
              label: {
                type: 'translatableText',
                translationKey: `sharedFlows_publicHealth:steps.employment_status.options.${option}`,
              },
            })
          ),
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('employment_status'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'income',
    subFlow: SubFlow.PublicHealth,
  } as const satisfies AnyStepConfiguration
}
